module.exports = __webpack_public_path__ + "static/media/welcomeimage3.69f2f979.jpg";